import React, { useEffect, useState, useContext, useCallback } from 'react';

import { Select, message, Input, Modal, Button, Switch } from 'antd';
import { withTranslation } from 'react-i18next';
import _ from 'underscore';

import {
  UserDetailHeadingCover,
  LoaderContainer,
  LineSeparator,
  StorageCardContainer,
  StorageHead,
  StorageButton,
  InputContainer,
  InputLabel,
  ToggleFeatures,
} from './styles';
import { ModalBody, ModalContainer } from '../../components/Modals/styles';
import {
  getAllSupportedLanguages,
  addLanguage,
  getAllLanguage,
  updateTranslatekey,
  updateLanguageTranslation,
  updateAiWriting,
} from '../../utils/services/languageApi';
import Loader from '../../components/Loader';
import { AppStoreContext } from '../../context/appStoreContext';
import { MANAGE_LANGUAGE_SETTINGS as trans } from './TranslationValues';
import UpgradePlanModal from '../../components/Modals/UpgradePlanModal';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import { fetchUserDetails } from '../../utils/services/authAPI';
import { ENTERPRISE_ENV, SUPPORT_EMAIL_ID } from '../../utils/helper';
import { useSessionContext } from '../../context/sessionContext';
import AutoCloseModal from '../../components/Modals/AutoCloseModal';

const { Option } = Select;
const NAMESPACE = ['MANAGE_LANGUAGE_SETTINGS'];

const LanguageSettings = props => {
  const {t} = props;
  const [loading, setLoading] = useState(true);
  const [allLanguages, setAllLanguages] = useState([]);
  const [availableLanguage, setAvailableLanguage] = useState([]);
  const [activeLang, setActiveLang] = useState([]);
  // const [activationKey, setActivationKey] = useState(null);
  const [enteredKey, setenterKey] = useState(null);
  const [activatingKey, setActivatingKey] = useState(false);
  const [languagesList, setLanguagesList] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [keyModalVisible, setKeyModalVisible] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isAPILoading, setIsAPILoading] = useState(false);
  const [langToDelete, setLangToDelete] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const { userDetails, setUserDetails, isEnterprise, checkUserAccess } = useContext(AppStoreContext);
  const organisationSelector = useCallback(store => store.organisationDetails, []);
  const [organisationDetails, setSessionContext] = useSessionContext(organisationSelector);
  const [enableTranslation, setEnableTranslation] = useState(
    ENTERPRISE_ENV && organisationDetails && organisationDetails.languageTranslation !== undefined
      ? organisationDetails.languageTranslation
      : true,
  );
  const [aiWriting, setEnableAiWriting] = useState(
    ENTERPRISE_ENV && organisationDetails && organisationDetails.aiWriting !== undefined
      ? organisationDetails.aiWriting
      : true,
  );
  const [confirmFeatureToggle, setConfirmFeatureToggle] = useState(null);
  const [enabledFeatureInfo, setEnabledFeatureInfo] = useState(null);
  let languageLimit = userDetails.planMapping && userDetails.planMapping.language || 1;
  let planName = userDetails?.planMapping?.planName;

  // Fetch all the supported languages
  const fetchAllLanguages = async () => {
    let response = await getAllSupportedLanguages();
    if (response && response.data) {
      setAllLanguages(response.data);
    }
  }

  // Fetch and update all the active languages
  const fetchData = async () => {
    const languagesExists = await getAllLanguage();
    setAvailableLanguage(languagesExists.data);
    let names = _.pluck(languagesExists.data, 'name');
    setActiveLang(names);

    let availLang = allLanguages.filter(data => !names.includes(data.name));
    setLanguagesList(availLang);

    setLoading(false);
  }

  useEffect(() => {
    fetchAllLanguages();
  }, []);

  useEffect(() => {
    if(allLanguages.length > 0)
    fetchData();
  }, [allLanguages]);  

  // Add languages

  const addNewLanguage = async () => {
    let Languages = [...availableLanguage];
    for (const list of selectedLanguages) {
      Languages.push(JSON.parse(list));
    }
    
    let response = await addLanguage({ Languages });
    if (response.statusCode === 116) {
      message.success(t(trans.ADD_LANGUAGE_SUCCESS_MESSAGE.key, trans.ADD_LANGUAGE_SUCCESS_MESSAGE.value));
      setSelectedLanguages([]);
      fetchData();
    } else {
      message.error(t(trans.ADD_LANGUAGE_SUCCESS_FAILURE.key, trans.ADD_LANGUAGE_SUCCESS_FAILURE.value));
    }
    setIsAPILoading(false);
  }

  const onSubmit = async () => {
    setIsAPILoading(true);
    if(isEnterprise || checkUserAccess('master')) {
      addNewLanguage();
      return;
    }
    // To find out the most recent limit, retrieve the data from this API
    let res = await fetchUserDetails();
    if(res && res.statusCode === 1903 && res.errors.length === 0) {
      languageLimit = res.data.planMapping.language && res.data.planMapping.language || 1;
      planName = res.data.planMapping.planName;
      setUserDetails(res.data);
    } else {
      message.error(t(trans.CHECKING_LANGUAGE_LIMIT_ERROR.key, trans.CHECKING_LANGUAGE_LIMIT_ERROR.value, { languageLimit }));
    }
    if((activeLang.length + selectedLanguages.length) > languageLimit) {
      setShowUpgradeModal(true);
    } else {
      addNewLanguage();
    }
    setIsAPILoading(false);
  };

  const activateAPI = async () => {
    setActivatingKey(true);
    let payload = {};
    payload.translateKey = enteredKey;
    let response = await updateTranslatekey(payload);
    if (response && response.errors) {
      if (response?.errors?.length === 0) {
        setKeyModalVisible(false);
        message.success(t(trans.UPDATING_GOOGLE_API_KEY_SUCCESS_MESSAGE.key,trans.UPDATING_GOOGLE_API_KEY_SUCCESS_MESSAGE.value));
      } else {
        message.error(t(trans.GOOGLE_API_KEY_UPDATION_FAILED_ERROR_MESSAGE.key,trans.GOOGLE_API_KEY_UPDATION_FAILED_ERROR_MESSAGE.value) + ' :: ', response?.errors[0]?.description);
      }
      setActivatingKey(false);
    }
  };

  // Delete a langauge
  const handleDeletion = async () => {
    setIsDeleting(true);
    const updatedAvailableLanguage = availableLanguage.filter((language) => langToDelete.includes(language.name));

    let Languages = updatedAvailableLanguage;
    let response = await addLanguage({ Languages });
      if (response.statusCode === 116) {
        setIsDeleting(false);
        setConfirmationModal(false);
        message.success(t(trans.LANGUAGE_DELETED_SUCCESS_MESSAGE.key, trans.LANGUAGE_DELETED_SUCCESS_MESSAGE.value));
        fetchData();  
      } else {
        message.error(t(trans.LANGUAGE_DELETED_FAILURE_MESSAGE.key, trans.LANGUAGE_DELETED_FAILURE_MESSAGE.value));
        setIsDeleting(false);
      }
  }

  const handleEnableLanguageTranslation = async checked => {
    if(checked) setEnabledFeatureInfo({ type: 'translation' });
    setEnableTranslation(checked);
    const payload = {
      value: checked,
    };
    try {
      const response = await updateLanguageTranslation(payload);
      if (response.statusCode === 523) {
        if(!checked) {
          setConfirmFeatureToggle(null);
          message.success(t(trans.AUTO_TRANSLATION_DISABLED_MESSAGE.key, trans.AUTO_TRANSLATION_DISABLED_MESSAGE.value));
        }
        setSessionContext({
          organisationDetails: { ...organisationDetails, languageTranslation: checked },
        });
      } else {
        message.error(t(trans.LANGUAGE_TRANSLATION_UPDATE_FAILED.key, trans.LANGUAGE_TRANSLATION_UPDATE_FAILED.value));
        setEnableTranslation(!checked);
      }
    } catch {
      message.error(t(trans.LANGUAGE_TRANSLATION_UPDATE_FAILED.key, trans.LANGUAGE_TRANSLATION_UPDATE_FAILED.value));
      setEnableTranslation(!checked);
    }
  };

  const handleAiWriting = async checked => {
    if(checked) setEnabledFeatureInfo({ type: 'aiWriting' });
    setEnableAiWriting(checked);
    const payload = {
      value: checked,
    };
    try {
      const response = await updateAiWriting(payload);
      if (response.statusCode === 525) {
        if(!checked) {
          setConfirmFeatureToggle(null);
          message.success(t(trans.AI_WRITING_DISABLED_MESSAGE.key, trans.AI_WRITING_DISABLED_MESSAGE.value));
        }
        setSessionContext({
          organisationDetails: { ...organisationDetails, aiWriting: checked },
        });
      } else {
        message.error(t(trans.AI_WRITING_UPDATE_FAILED.key, trans.AI_WRITING_UPDATE_FAILED.value));
        setEnableAiWriting(!checked);
      }
    } catch {
      message.error(t(trans.AI_WRITING_UPDATE_FAILED.key, trans.AI_WRITING_UPDATE_FAILED.value));
      setEnableAiWriting(!checked);
    }
  };

  const toggleFeatureConfig = {
    translation: {
      onConfirm: () => handleEnableLanguageTranslation(confirmFeatureToggle?.value),
      confirmationText: t(trans.AUTO_TRANSLATION_DISABLE_CONFIRM_MESSAGE.key, trans.AUTO_TRANSLATION_DISABLE_CONFIRM_MESSAGE.value),
      enableText: t(trans.AUTO_TRANSLATION_ENABLE_SUCCESS_MESSAGE.key, trans.AUTO_TRANSLATION_ENABLE_SUCCESS_MESSAGE.value),
    },
    aiWriting: {
      onConfirm: () => handleAiWriting(confirmFeatureToggle?.value),
      confirmationText: t(trans.AI_WRITING_DISABLE_CONFIRM_MESSAGE.key, trans.AI_WRITING_DISABLE_CONFIRM_MESSAGE.value),
      enableText: t(trans.AI_WRITING_ENABLE_SUCCESS_MESSAGE.key, trans.AI_WRITING_ENABLE_SUCCESS_MESSAGE.value),
    }
  }

  return (
    <>
      {loading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <>
          <UserDetailHeadingCover separator>
            <div>
              <h5>{t(trans.MANAGE_LANGUAGE_SETTINGS_TITLE.key,trans.MANAGE_LANGUAGE_SETTINGS_TITLE.value)}</h5>
              <p>{t(trans.MANAGE_LANGUAGE_SETTINGS_DESCRIPTION.key,trans.MANAGE_LANGUAGE_SETTINGS_DESCRIPTION.value)}</p>
            </div>
          </UserDetailHeadingCover>
          <LineSeparator />
          <StorageHead>{isEnterprise ? t(trans.ENABLED_LANGUAGES_LABEL.key,trans.ENABLED_LANGUAGES_LABEL.value) : t(trans.MANAGE_AVAILABLE_LANGUAGES_LABEL.key,trans.MANAGE_AVAILABLE_LANGUAGES_LABEL.value)} ({activeLang.length})</StorageHead>
          <Select
            mode="tags"
            size="large"
            value={activeLang}
            onChange={(e) => {
              setLangToDelete(e);
              setConfirmationModal(true);
            }}
            open={false}
            className='availableLanguages'
          />
          <StorageCardContainer>
            <Select
              mode="multiple"
              style={{ width: '70%' }}
              placeholder={t(trans.EMPTY_LANGUAGES_WARNING_MESSAGE.key,trans.EMPTY_LANGUAGES_WARNING_MESSAGE.value)}
              onChange={data => setSelectedLanguages(data)}
              value={selectedLanguages}
            >
              {languagesList.map(data => {
                return (
                  <Option key={data.code} value={JSON.stringify(data)}>
                    {data.name}
                  </Option>
                );
              })}
            </Select>
          </StorageCardContainer>
          <div style={{ width: '70%', marginTop: '25px', marginBottom: ENTERPRISE_ENV ? '' : '6rem' }}>
            <StorageButton 
            loading={isAPILoading}
            onClick={onSubmit}
            disabled={selectedLanguages.length === 0} 
            language={1}
            icon={'plus'} >
             { isAPILoading ? t(trans.PLEASE_WAIT_MESSAGE.key, trans.PLEASE_WAIT_MESSAGE.value) :
              t(trans.ADD_SELECTED_LANGUAGES_BUTTON.key, trans.ADD_SELECTED_LANGUAGES_BUTTON.value) }
            </StorageButton>
          </div>
          {ENTERPRISE_ENV ? (
            <>
              <LineSeparator />
              <ToggleFeatures>
              <div className='toggle-container'>
                <div>
                  <h6>{t(trans.AUTO_TRANSLATION_FEATURE_LABEL.key, trans.AUTO_TRANSLATION_FEATURE_LABEL.value)}</h6>
                  <p>{t(trans.AUTO_TRANSLATION_FEATURE_DESCRIPTION.key, trans.AUTO_TRANSLATION_FEATURE_DESCRIPTION.value)}</p>
                </div>
                <div>
                <Switch
                  checked={enableTranslation}
                  onChange={(checked) =>
                    checked
                      ? handleEnableLanguageTranslation(checked)
                      : setConfirmFeatureToggle({ type: 'translation', value: checked })
                  }
                />
                </div>
              </div>
              <div className='toggle-container'>
                <div>
                  <h6>{t(trans.AI_WRITING_FEATURE_LABEL.key, trans.AI_WRITING_FEATURE_LABEL.value)}</h6>
                  <p>{t(trans.AI_WRITING_FEATURE_DESCRIPTION.key, trans.AI_WRITING_FEATURE_DESCRIPTION.value)}</p>
                </div>
                <div>
                <Switch
                  checked={aiWriting}
                  onChange={(checked) =>
                    checked
                      ? handleAiWriting(checked)
                      : setConfirmFeatureToggle({ type: 'aiWriting', value: checked })
                  }
                />
                </div>
              </div>
              </ToggleFeatures>
            </>
          ) : null}
          <ConfirmationModal
            showImage={false}
            visibility={confirmFeatureToggle?.type || false}
            onCancel={() => setConfirmFeatureToggle(null)}
            onConfirm={() => toggleFeatureConfig[confirmFeatureToggle?.type]?.onConfirm()}
            confirmationText={toggleFeatureConfig[confirmFeatureToggle?.type]?.confirmationText}
            confirmButtonText={t(trans.PROCEED_BUTTON_LABEL.key, trans.PROCEED_BUTTON_LABEL.value)}
          />
          <AutoCloseModal 
            visible={enabledFeatureInfo?.type}
            onClose={() => setEnabledFeatureInfo(null)}
            text={toggleFeatureConfig[enabledFeatureInfo?.type]?.enableText} />
          {/* { isEnterprise && (<>
            <LineSeparator />
            <StorageHead>{t(trans.GOOGLE_API_KEY_USED_LABEL.key,trans.GOOGLE_API_KEY_USED_LABEL.value)}</StorageHead>
            <StorageCardContainer>
              <Input
                name="googleApiKey"
                size="large"
                placeholder={t(trans.ENTER_GOOGLE_API_KEY_PLACEHOLDER.key,trans.ENTER_GOOGLE_API_KEY_PLACEHOLDER.value)}
                className="googleAPIkey"
                value={activationKey}
                readOnly={true}
                addonAfter={<Icon type={'edit'} onClick={() => setKeyModalVisible(true)} />}
              />
            </StorageCardContainer>
          </>)} */}
        </>
      )}
      <Modal
        title={t(trans.ENTER_GOOGLE_API_KEY_MODAL_TITLE.key,trans.ENTER_GOOGLE_API_KEY_MODAL_TITLE.value)}
        centered
        maskClosable={false}
        visible={keyModalVisible}
        width="625px"
        onCancel={() => {
          setKeyModalVisible(false);
        }}
        footer={false}
        className="warning-modal"
      >
        <ModalBody>
          <ModalContainer>
            <InputContainer full={true}>
              <Input
                name="googleApiKey"
                size="large"
                onChange={e => setenterKey(e.target.value)}
                autoComplete={'off'}
              />
              <div className="form_btn">
                <Button
                  key="submit"
                  type="primary"
                  disabled={!enteredKey}
                  loading={activatingKey}
                  onClick={activateAPI}
                >
                  {t(trans.ACTIVATE_VALID_API_KEY_BUTTON.key,trans.ACTIVATE_VALID_API_KEY_BUTTON.value)}
                </Button>
              </div>
            </InputContainer>
          </ModalContainer>
        </ModalBody>
      </Modal>
      <UpgradePlanModal 
        visible={showUpgradeModal}
        modalText={ planName === 'Premium' ?
          t(trans.PREMIUM_PLAN_UPGRADE_MESSAGE.key, trans.PREMIUM_PLAN_UPGRADE_MESSAGE.value, { emailId: SUPPORT_EMAIL_ID })
        : planName === 'Free' ? 
          t(trans.FREE_PLAN_UPGRADE_MESSAGE.key, trans.FREE_PLAN_UPGRADE_MESSAGE.value, { languageLimit })
          : t(trans.STANDARD_PLAN_UPGRADE_MESSAGE.key, trans.STANDARD_PLAN_UPGRADE_MESSAGE.value, { languageLimit })}
        onCancel={() => setShowUpgradeModal(false)}
      />
      <ConfirmationModal
        showImage={false}
        visibility={confirmationModal}
        onCancel={() => setConfirmationModal(false)}
        onConfirm={() => handleDeletion()}
        confirmationText={t(trans.DELETE_LANGUAGE_CONFIRMATION_MESSAGE.key, trans.DELETE_LANGUAGE_CONFIRMATION_MESSAGE.value)}
        confirmButtonText={
          isDeleting
            ? t(trans.PLEASE_WAIT_MESSAGE.key, trans.PLEASE_WAIT_MESSAGE.value)
            : t(trans.DELETE_CONFIRM_BUTTON.key, trans.DELETE_CONFIRM_BUTTON.value)
          }
        isLoading={isDeleting}
      />
    </>
  );
};
export default withTranslation(NAMESPACE)(LanguageSettings);
